import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { Stack, Tooltip, Typography } from '@mui/material';

import { QuickFilterConfig } from '../../types';

interface Props {
  config: QuickFilterConfig;
}

export const QuickFilterLabel = ({ config }: Props) => (
  <Stack direction="row" alignItems="center" gap="0.25rem">
    <Typography>{config.label}</Typography>

    {config.tooltip && (
      <Tooltip title={config.tooltip} arrow>
        <InfoOutlined sx={{ fontSize: 14 }} />
      </Tooltip>
    )}
  </Stack>
);
